import React, { Component } from "react";
import jsyaml from "js-yaml";
import "swagger-ui/dist/swagger-ui.css";
import SwaggerUi, { presets } from "swagger-ui";
import SwaggerAPI from "../../api/SwaggerAPI";
import TopMenu from './TopMenu';

class ContentView extends Component {
  state = {
    swagger: null,
    groupId: null,
    versions: []
  };

  renderSwagger = (swagger) => {
    this.setState({ swagger });

    let contentAsJson = {};
    try {
      contentAsJson = JSON.parse(swagger.content);
    } catch (e) {
      if (swagger !== null) {
        contentAsJson = jsyaml.safeLoad(swagger.content);
      }
    }

    SwaggerUi({
      dom_id: "#swagger-container",
      spec: contentAsJson,
      presets: [presets.apis],
      requestInterceptor: function (request) {
        if (request.loadSpec) {
          request.headers.Authorization =
            "Bearer " +
            localStorage.getItem("access_token");
        }
        return request;
      }
    });
  }

  componentWillReceiveProps = ({ groupId, swaggerId }) => {
    if (!groupId || !swaggerId) {
      return;
    }

    this.setState({ groupId });

    SwaggerAPI.getSwagger(groupId, swaggerId)
      .then(this.renderSwagger);

    SwaggerAPI.getSwaggerVersions(groupId, swaggerId).then(versions => {
      this.setState({ versions })
    });
  }

  onVersionChanged = (event) => {
    SwaggerAPI.getSwaggerVersion(this.props.groupId, this.props.swaggerId, event.target.value)
      .then(this.renderSwagger);
  }

  reloadSwaggers = () => {
    this.setState({ swagger: null })
    this.props.reloadSwaggers();
  }

  render() {
    return (
      <div className="scrollable-content">
        <TopMenu
          onCompareSwagger={this.props.onCompareSwagger}
          onEditSwagger={this.props.onEditSwagger}
          swagger={this.state.swagger}
          groupId={this.state.groupId}
          versions={this.state.versions}
          onVersionChanged={this.onVersionChanged}
          reloadSwaggers={this.reloadSwaggers} />
        <div className="swagger-content-view">
          <div id="swagger-container"></div>
        </div>
      </div>
    );
  }
}

export default ContentView;



// WEBPACK FOOTER //
// ./src/components/swagger-view/ContentView.js